import React, { useCallback, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { routes } from "./config/route.config";
import PageNotFound from "./pages/404";
import { useAppSelector, useAppDispatch } from "./redux/store";
import { RedirectPath } from "./enum/auth";
import { getBusinessThunk } from "./redux/thunks/user.thunk";

function App() {
  const dispatch = useAppDispatch();
  const auth = useAppSelector((state) => state.auth);
  const business = useAppSelector((state) => state.user.business);

  useEffect(() => {
    dispatch(getBusinessThunk());
  }, [dispatch]);

  const getComponent = useCallback(
    (component: React.ComponentType, isPublic?: boolean) => {
      if (
        (isPublic && !auth.token) ||
        (business.isLoading && auth.login.isLoading && auth.signUp.isLoading)
      ) {
        return component;
      }

      if (!isPublic && auth.token) {
        return component;
      }

      return () => (
        <Navigate to={isPublic ? RedirectPath.DASHBOARD : RedirectPath.LOGIN} />
      );
    },
    [business, auth],
  );

  return (
    <div className="App">
      <Routes>
        {routes.map(({ component, path, isPublic }) => (
          <Route
            Component={getComponent(component, isPublic)}
            path={path}
            key={path}
          />
        ))}
        <Route path="/" element={<Navigate to={RedirectPath.LOGIN} />} />
        <Route path="*" Component={PageNotFound} />
      </Routes>
    </div>
  );
}

export default App;
